import { DimensionTypes } from "./DimensionTypes/DimensionTypes";
import { Size } from "./Size/Size";
import { Percentage } from "./Percentage/Percentage";
import { useResizeSettings } from "./useResizeSettings";
import { FillColor } from "./FillColor/FillColor";
import { DesktopAction } from "../../Action/DesktopAction";
import { Translate } from "components/common/Translate/Translate";

interface ResizeSettingsProps {
    hideTitle?: boolean;
}

export const ResizeSettings = ({ hideTitle }: ResizeSettingsProps) => {
    const { dimensionType, isLocked } = useResizeSettings();

    return (
        <div className="flex flex-col justify-between h-full text-black dark:text-white">
            <div className="flex flex-col gap-6 px-4 border-r border-r-irGray-200 dark:border-r-darkSurface-400">
                {!hideTitle && (
                    <div
                        className="capitalize text-2xl font-semibold whitespace-nowrap pt-4"
                        data-testid={`image-enlarger-title`}
                    >
                        <Translate keyName="image-enlarger" />
                    </div>
                )}
                <DimensionTypes />
                {dimensionType === "pixels" ? (
                    <>
                        <Size />
                        {!isLocked && <FillColor />}
                    </>
                ) : (
                    <Percentage />
                )}
            </div>
            <div className="hidden lg:block bg-white dark:bg-darkSurface-100 border-t border-t-irGray-200 dark:border-t-darkSurface-600 pt-4 my-4">
                <DesktopAction />
            </div>
        </div>
    );
};
